module.exports = __webpack_public_path__ + "img/sapienza.8ec320e5.png";